import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/regulatory-affairs-para-dispositivos-medicos")({
  head: () => buildRouteHead("/es/servicios/regulatory-affairs-para-dispositivos-medicos", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/regulatory-affairs", replace: true });
  },
});
